import { useMemo } from "react";
import { createTracker } from "./engine";

// One tracker per distinct pixel list. Adapters load scripts and init IDs once per page,
// so a second tracker (StrictMode double render) adds nothing.
// Loading happens here, in render; the adapters make it idempotent.
export default function useTracking(pixels) {
  const signature = JSON.stringify(pixels || []);
  return useMemo(() => {
    try {
      return createTracker(JSON.parse(signature));
    } catch (e) {
      console.error("tracking: setup failed", e);
      return { emit() {} };
    }
  }, [signature]);
}
